import CircularLoader from "../common/CircularLoader/CircularLoader";
import { type ConnectionPhase } from "./gstUtils";
import styles from "../../pages/GSTReconciliation/GSTReconciliation.module.scss";

interface GSTProgressStatusProps {
  phase: ConnectionPhase;
  /** Overrides the default phase label (e.g. a consumer-specific wording). */
  label?: string;
}

/**
 * Renders the connection progress indicator for a GST account row.
 *
 * - `connected` → green "Connected" badge
 * - `failed` → null (caller renders a Reconnect button)
 * - `verifying` / `accessing` / `fetching` → spinner + phase label
 */
export default function GSTProgressStatus({ phase, label: labelOverride }: GSTProgressStatusProps) {
  if (phase === "connected") {
    return <span className={styles.connectedBadge}>Connected</span>;
  }

  if (phase === "failed") {
    return null;
  }

  const label =
    labelOverride ??
    (phase === "verifying"
      ? "Verifying credentials"
      : phase === "accessing"
      ? "Accessing your GST portal"
      : "Fetching GSTR-2B data");

  return (
    <span className={styles.fetchingStatus}>
      <CircularLoader width="1.25rem" height="1.25rem" backgroundColor="#fff" />
      {label}
    </span>
  );
}